import { render } from "./Belbin.vue?vue&type=template&id=fbd28370&scoped=true&lang=html"
import script from "./Belbin.vue?vue&type=script&lang=js"
export * from "./Belbin.vue?vue&type=script&lang=js"

import "./Belbin.vue?vue&type=style&index=0&id=fbd28370&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-fbd28370"

export default script